import React, { useReducer, useMemo, useEffect, useContext, useState } from "react";
import PropTypes from 'prop-types';
import AuthReducer, {
    initialState,
    LOGGED_IN,
    LOGGED_OUT,
} from '../reducers/AuthReducer';
import { asyncStoreClear, asyncStoreGet, asyncStoreSave } from "../Utils/asyncStorage";
import debugLogger from "../Utils/debugLogger";
import UserService from "../../api/services/UserService";
import { TOKEN_KEY, LOGIN_KEY, USER_KEY } from '../contants/authKeys';

export const keys = [LOGIN_KEY];

const initialContext = initialState;

const AuthContext = React.createContext(initialContext);
console.log("^^",AuthContext)
export function AuthProvider(props) {
  //  const [isLogin, setIsLogin] = useState(false);
    const [authState, dispatch] = useReducer(AuthReducer, initialState || {});

    useEffect(() => {
        // Fetch the token from storage then navigate to our appropriate place
        const bootstrapAsync = async () => {
            try {
                //GET TOKEN && USER
                let isAuth = await asyncStoreGet(LOGIN_KEY);
                debugLogger('AuthProvider: bootstrapAsync token:', isAuth);
                //&& user !== null
                if (isAuth !== null) {
                    await login({ isAuth, initialiseUser: true });
                } else await logout();
            } catch (err) {
                throw err.error;
            }
        };

        bootstrapAsync();
    }, []);


    // Handle Login
    const login = async data => {
        try {
            // If called during bootstrap to initialise user, just dispatch login if stored
            if (data && data.initialiseUser) {
                debugLogger('AuthProvider.login: initialiseUser');
                dispatch({ type: LOGGED_IN });
                return { success: true, data: null };
            }

            const response = await UserService.login(data);
            console.debug('AuthProvider.login: service response', response);

            if (response && response.success) {
                const resultData = response.data || {};
                // Try multiple possible token locations for robustness
                const token = resultData.token || resultData.accessToken ||
                    (response.response && (response.response.token || (response.response.data && response.response.data.token))) ||
                    null;
                if (token) {
                    console.debug('AuthProvider.login: saving auth_token', token && token.substr ? `${token.substr(0, 8)}...` : token);
                    await asyncStoreSave(TOKEN_KEY, token);
                } else {
                    console.debug('AuthProvider.login: no token found in response');
                }

                // Persist login flag and userId if present
                await asyncStoreSave(LOGIN_KEY, true);
                if (resultData && resultData.userId) {
                    await asyncStoreSave(USER_KEY, resultData.userId);
                }

                dispatch({ type: LOGGED_IN });
                return { success: true, data: resultData, response: response.response || null };
            }

            // On failure, return the normalized failure object from service
            return response || { success: false, error: 'Login failed' };
        } catch (err) {
            debugLogger('login error: ', err);
            await logout();
            return { success: false, error: err.message || err };
        }
    };


    const logout = async () => {
        try {
            //REMOVE DATA
            await asyncStoreClear();
            //DISPATCH TO REDUCER
            dispatch({ type: LOGGED_OUT });
        } catch (err) {
            debugLogger('logout error: ', err);
            throw err.error;
        }
    };


    const value = useMemo(
        () => [
            authState,
            {
                login,
                logout,
            },
        ],
        [authState],
    );

    return (
        <AuthContext.Provider value={value}>{props.children}</AuthContext.Provider>
    );
}

const useAuth = () => useContext(AuthContext);

export { AuthContext, useAuth };

AuthProvider.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};


// export const AuthContext = React.createContext({});

// export const AuthProvider = ({ children }) => {
//     const [isLogin, setIsLogin] = useState(false);

//     React.useEffect(() => {
//         handleAuthenticated();
//     }, []);

//     const handleAuthenticated = async () => {

//         const isAuthenticated = await localStorage.getItem("isLogin");
//         if (isAuthenticated === "true") {
//             setIsLogin(true);
//         } else {
//             await localStorage.setItem("isLogin", false);
//             setIsLogin(false);
//         }
//     };

//     return (
//         <AuthContext.Provider
//             value={{
//                 isLogin,
//                 handleAuthenticated: handleAuthenticated,
//             }}
//         >
//             {children}
//         </AuthContext.Provider>
//     );
// };
